import styled from 'styled-components';

export const $InternationalAvsBannerWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  right: 32px;
  z-index: 1001;
`;

export const $BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 32px 36px;
  gap: 12px;
  isolation: isolate;
  position: relative;
  width: 360px;
  height: calc(100vh - 100px);
  max-height: 700px;
  background: linear-gradient(180deg, #1a1a1e 100%, #1a1a1e 100%);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  overflow: visible;
  perspective: 400px;
`;

export const $InnerBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 60%;
  top: 0;
  left: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 58, 37, 0.3) 0%,
    rgba(0, 21, 14, 0.3) 68.63%
  );
  border-radius: 16px;
  z-index: 0;
`;

export const $GlobeContainer = styled.div`
  position: absolute;
  width: 95%;
  height: 148%;
  left: 15px;
  transform-origin: center center;
  transform: none;
  z-index: 2;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const $ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0;
  gap: 16px;
  width: 100%;
  z-index: 1;
  position: relative;
  height: 40%;
`;

export const $TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 12px;
  width: 100%;
`;

export const $HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 6px;
  width: 100%;

  .subtitle {
    font-family: 'SF Pro Text', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.06em;
    color: #00d999;
    text-transform: uppercase;
  }

  .title {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 1.1;
    color: #ffffff;
    letter-spacing: 0.5px;
  }
`;

export const $FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 8px 0 12px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  li {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;

    &:before {
      content: '•';
      margin-right: 8px;
      font-size: 20px;
      font-weight: bold;
      opacity: 0.2;
    }
  }
`;

export const $ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const baseButtonStyles = `
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  white-space: nowrap;
`;

export const $RequestAccessButton = styled.button`
  ${baseButtonStyles};
  background: #ffffffff;
  color: #1a1a1e;
  height: 48px;
  font-family: 'Inter', sans-serif;
  line-height: 135%;

  &:hover {
    background: #ffffffee;
  }

  &.disabled {
    opacity: 0.6;
    cursor: default;

    &:hover {
      background: #ffffffff;
    }
  }
`;

export const $ReadMoreButton = styled.button`
  ${baseButtonStyles};
  background: transparent;
  color: #dadae2;
  border: 1px solid #dadae2;
  padding: 6px 24px;
  height: 48px;
  font-family: 'SF Pro Text', sans-serif;
  line-height: 18px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.6);
  }
`;
